import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [];

  initialize() {
    this.highlightItem();
    window.addEventListener('hashchange', this.highlightItem.bind(this));
  }

  highlightItem() {
    const ANIMATION_TIMEOUT = 8000;
    const OFFSET = 48 + 16; // header height + padding
    const activeClass = 'highlight';

    const hash = window.location.hash;
    const $target = hash && document.querySelector(hash) || null;

    if ($target) {
      // $nextTick emulation
      setTimeout(() => {
        $target.classList.add(activeClass);
        $target.blur();

        // scroll to the target if it's not visible
        window.scrollTo({
          top: $target.getBoundingClientRect().top + window.pageYOffset - OFFSET,
          behavior: 'smooth'
        });
      }, 1);

      setTimeout(() => {
        $target.classList.remove(activeClass);
      }, ANIMATION_TIMEOUT);
    }
  }
};
